import axios from 'axios';

// Strip any trailing slash from the env var to prevent double-slash URLs
const BASE = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/api`
  : '/api';

const API = axios.create({ baseURL: BASE });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('mds_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('mds_token');
      localStorage.removeItem('mds_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const register = (data) => API.post('/auth/register', data);
export const login = (data) => API.post('/auth/login', data);
export const getMe = () => API.get('/auth/me');
export const updateProfile = (data) => API.put('/auth/profile', data);
export const changePassword = (data) => API.put('/auth/change-password', data);
export const resendVerification = (email) => API.post('/auth/resend-verification', { email });
export const forgotPassword = (email) => API.post('/auth/forgot-password', { email });
export const resetPassword = (data) => API.post('/auth/reset-password', data);

// Bookings
export const createBooking = (data) => API.post('/bookings', data);
export const createGuestBooking = (data) => API.post('/public/bookings', data);
export const getMyBookings = (params) => API.get('/bookings/my', { params });
export const cancelBooking = (uuid, data) => API.put(`/bookings/${uuid}/cancel`, data);
export const downloadReceipt = (uuid) => API.get(`/bookings/${uuid}/receipt`, { responseType: 'blob' });
export const adminDownloadReceipt = (uuid) => API.get(`/admin/bookings/${uuid}/receipt`, { responseType: 'blob' });

// Notifications
export const getNotifications = () => API.get('/notifications');
export const markAllRead = () => API.put('/notifications/read-all');

// Public
export const getTestimonials = () => API.get('/public/testimonials');
export const getServiceAreas = () => API.get('/public/service-areas');
export const submitContact = (data) => API.post('/public/contact', data);

// Admin
export const getAdminStats = () => API.get('/admin/stats');
export const getAdminBookings = (params) => API.get('/admin/bookings', { params });
export const updateAdminBooking = (uuid, data) => API.put(`/admin/bookings/${uuid}`, data);
export const getAdminUsers = (params) => API.get('/admin/users', { params });
export const toggleUserStatus = (id) => API.put(`/admin/users/${id}/toggle`);
export const getDrivers = () => API.get('/admin/drivers');
export const createDriver = (data) => API.post('/admin/drivers', data);
export const updateDriver = (id, data) => API.put(`/admin/drivers/${id}`, data);
export const getContacts = () => API.get('/admin/contacts');
export const getAdmins = () => API.get('/admin/admins');
export const createAdmin = (data) => API.post('/admin/admins', data);

export default API;
